export const defaultSizes = [
  {
    title: 'Europall',
    length: 1.2,
    width: 0.8,
  },
  {
    title: 'Finpall',
    length: 1.2,
    width: 1,
  },
  {
    title: 'UKpall',
    length: 1.2,
    width: 1.2,
  },
];
